import React from 'react'
import { NavLink } from 'react-router-dom'
import { GroundWaterIcon, TimelineIcon } from '../../icons'
import { NavIcon, ScreenNavWrapper } from './Navigation.styles'
import { MdHome } from 'react-icons/md'

const ScreenNav = () => {
  const NavCustomLinks = [
    {
      title: {
        en: 'home',
        ar: 'home'
      },
      link: '/',
      key: 'h-nav-3',
      icon: () => <MdHome />
    },
    {
      title: {
        en: 'map',
        ar: 'الخريطة'
      },
      link: '/map',
      key: 'h-nav-1',
      icon: () => <GroundWaterIcon />
    },
    {
      title: {
        en: 'timeline',
        ar: 'الجدول الزمني'
      },
      link: '/timeline',
      key: 'h-nav-2',
      icon: () => <TimelineIcon />
    }
  ]
  return (
    <ScreenNavWrapper>
      {NavCustomLinks.map(({ key, link, icon }) =>
        link === '/' ? (
          <NavLink exact activeClassName="active" key={key} to={link}>
            <NavIcon>{icon()}</NavIcon>
          </NavLink>
        ) : (
          <NavLink activeClassName="active" key={key} to={link}>
            <NavIcon>{icon()}</NavIcon>
          </NavLink>
        )
      )}
    </ScreenNavWrapper>
  )
}

export default ScreenNav
